var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-main"},[_c('Nav'),_c('div',{staticClass:"body-container"},[_c('div',{staticClass:"contenedor-body",staticStyle:{"padding":"14px"}},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }